export class Address {
    id: number;
    addressName:string;
    postalCode: string;
    province: string    
} 